import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { GlobalStateService } from 'src/app/services/global/global-state.service';

@Component({
  selector: 'app-shipping-and-documents',
  templateUrl: './shipping-and-documents.component.html',
  styleUrls: ['./shipping-and-documents.component.scss']
})
export class ShippingAndDocumentsComponent extends DestructorComponent {
  masterDataChildren: Route[] = [];
  user: any;
  constructor(private router: Router, private _globalStateService: GlobalStateService) { super(); }

  ngOnInit(): void {
    const masterDataRoute = this.router.config.find(r => r.path === 'shipping-and-docs');

    // Get only first-level children
    this.masterDataChildren = masterDataRoute?.children ?? [];

    this.subscriptions.push(
      this._globalStateService.user.subscribe(user => {
        this.user = user;

        if (this.user?.role_complete.is_admin) {
          this.masterDataChildren = masterDataRoute?.children ?? [];
        }
        else {
          this.masterDataChildren = this.masterDataChildren.filter((child: any) => {
            return this.user?.role_complete.permissions[child.path]?.view;
          });
        }
      })
    );
  }
}
